// src/features/settings/components/SettingsHeader.tsx
import { PageHeader } from '../../../app/components/foundation';

/**
 * Page-top header for Settings Foundation. Reuses the shared
 * PageHeader primitive (same contract every other feature's header
 * uses) and puts one disabled placeholder in the actions slot to
 * reserve visual space for a future "افزودن گروه تنظیمات" action. It
 * has no click handler and does nothing yet — wiring it to a real
 * create flow is a later phase, not this one. Same pattern as
 * permissions/components/PermissionsHeader.tsx and
 * analytics/components/AnalyticsHeader.tsx.
 */
export function SettingsHeader() {
  return (
    <PageHeader
      title="تنظیمات"
      description="مشاهده و مدیریت گروه‌های تنظیمات پلتفرم و مقادیر پیکربندی آن‌ها."
      actions={
        <button
          type="button"
          disabled
          className="vania-settings-action-placeholder"
          title="در فاز بعدی فعال می‌شود"
        >
          افزودن گروه تنظیمات
        </button>
      }
    />
  );
}
